import {
  LineChart,
  Line,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  ResponsiveContainer,
} from 'recharts';
import { tokens } from '@redbax/shared';
import { Card, CardContent, CardHeader, CardTitle } from '../components/ui/card';

interface TrendLineProps {
  data: Array<{ date: string; count: number }>;
  title?: string;
  loading?: boolean;
}

export function TrendLine({ data, title = 'Detection Trends', loading }: TrendLineProps) {
  if (loading) {
    return (
      <Card>
        <CardHeader>
          <CardTitle className="text-base">{title}</CardTitle>
        </CardHeader>
        <CardContent>
          <div className="h-[250px] animate-pulse rounded bg-surface-raised" />
        </CardContent>
      </Card>
    );
  }

  if (data.length === 0) {
    return (
      <Card>
        <CardHeader>
          <CardTitle className="text-base">{title}</CardTitle>
        </CardHeader>
        <CardContent>
          <div className="flex h-[250px] items-center justify-center text-sm text-text-secondary">
            No trend data available
          </div>
        </CardContent>
      </Card>
    );
  }

  return (
    <Card>
      <CardHeader>
        <CardTitle className="text-base">{title}</CardTitle>
      </CardHeader>
      <CardContent>
        <div className="h-[250px]">
          <ResponsiveContainer width="100%" height="100%">
            <LineChart data={data}>
              <CartesianGrid strokeDasharray="3 3" stroke={tokens.colors.border} />
              <XAxis
                dataKey="date"
                stroke={tokens.colors.textSecondary}
                fontSize={12}
              />
              <YAxis stroke={tokens.colors.textSecondary} fontSize={12} />
              <Tooltip
                contentStyle={{
                  backgroundColor: tokens.colors.surface,
                  border: `1px solid ${tokens.colors.border}`,
                  borderRadius: '6px',
                  color: tokens.colors.textPrimary,
                }}
              />
              <Line
                type="monotone"
                dataKey="count"
                stroke={tokens.colors.redAccent}
                strokeWidth={2}
                dot={{ fill: tokens.colors.redAccent, r: 3 }}
                activeDot={{ r: 5 }}
              />
            </LineChart>
          </ResponsiveContainer>
        </div>
      </CardContent>
    </Card>
  );
}
